export const intellectualPropertyandCopyrightNotices = [
  {
    header: "Ownership Rights",
    answer:
      "Any content (photos, videos, images, information) you post on the platform is owned by you or the original creator.",
  },
  {
    header: "Granting Us Usage Rights",
    answer:
      "By uploading your content, you provide HomeSwap with a broad license to use it. This license is non-exclusive, transferable, sublicensable, royalty-free, and applies worldwide. It permits us to: \n \n \
        • Use, copy, and modify the content as needed. \n \n \
        • Publish, promote, and display the content across various platforms. \n \n \
        • Edit or enhance the content to suit different contexts. \n \n \
        • Distribute the content without needing to attribute authorship or ownership.",
  },
  {
    header: "Your Warranty",
    answer:
      "You confirm that you have the necessary rights to share the content and grant us this license. Ensure you have permission from the creator and anyone featured in the content before posting.",
  },
  {
    header: "No Obligation to Attribute",
    answer:
      "We have the right to use your content without needing to provide attribution, maintain confidentiality, or compensate you for its use.",
  },
];
